export default "__VITE_ASSET__Ce$0YHPk__"